import React, { useEffect } from "react";

interface Subscription {
  tier: string;
  status: string;
  interval: string;
  nextPaymentDate?: string;
}

interface SubscriptionStatusProps {
  subscription: Subscription;
  onManageSubscription: () => void;
  onRenewal: () => void;
}

export default function SubscriptionStatus({
  subscription,
  onManageSubscription,
  onRenewal,
}: SubscriptionStatusProps) {

  const status = subscription?.status || '';
  const tier = subscription?.tier || '';
  const interval = subscription?.interval || '';
  const nextPaymentDate = subscription?.nextPaymentDate;

  return (
    <div
      id="subscription-status"
      style={{ maxWidth: "500px" }}
      className="mt-8 bg-white dark:bg-gray-800 shadow rounded-lg p-6"
    >
      <div className="space-y-6">
        <div>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
            <h2 className="text-xl font-semibold">Subscription Status</h2>
            <button
              className="mt-4 md:mt-0 px-4 py-2 bg-secondary dark:bg-secondary hover:bg-secondary-dark dark:hover:bg-secondary-dark text-white rounded-lg transition-colors w-[200px] text-sm"
              onClick={onManageSubscription}
            >
              Manage Subscription
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-gray-500">Current Plan</p>
              <p className="text-lg font-medium capitalize">
                {tier}
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Billing Cycle</p>
              <p className="text-lg font-medium capitalize">
                {status.includes("cancel")
                  ? "---"
                  : interval}
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Status</p>
              <span
                className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-sm font-medium ${status === "active"
                  ? "bg-green-100 text-green-800"
                  : "bg-yellow-100 text-yellow-800"
                  }`}
              >
                {status.charAt(0).toUpperCase() + status.slice(1)}
              </span>
            </div>
            <div>
              <p className="text-sm text-gray-500">Next Payment</p>
              <p className="text-lg font-medium">
                {status.includes("active until") ||
                  status.includes("cancel")
                  ? "---"
                  : nextPaymentDate &&
                  new Date(nextPaymentDate).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "2-digit",
                  })}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
